import styled from '@emotion/styled';
import { ExerciseUI } from '@seedlang/state';
import { isPresent } from '@seedlang/utils';
import Tags from 'components/worksheet/tags';
import InfoTooltip from 'components/info_tooltip';
import { startCase } from 'lodash';
import { observer } from 'mobx-react';
import React from 'react';
import ReactTooltip from 'react-tooltip';

const SubtitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
`;

const PublicationDate = styled.div`
  font-size: 14px;
  color: #636363;
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
`;

const WorksheetSubtitleRow = observer(() => {
  if (!ExerciseUI.worksheet) {
    return null;
  }

  const goBackToPosts = () => {
    const targetNamespace = ExerciseUI.worksheetNamespace === 'learn' ? 'videos' : ExerciseUI.worksheetNamespace;
    ExerciseUI.routeStore.routeToNamed(`${targetNamespace}.index`);
  };

  return (
    <SubtitleRow>
      <PublicationDate
        data-tip
        data-for='publication-date'
      >
        {isPresent(ExerciseUI.worksheet.publishedAt) && ExerciseUI.worksheet.publishedAt.relativeTime}
        {
          !ExerciseUI.worksheet.contentPublishedOnADifferentDay &&
            <ReactTooltip
              place='right'
              type='light'
              effect='float'
              id='publication-date'
              class='custom-tooltip'
            >
              {isPresent(ExerciseUI.worksheet.publishedAt) && ExerciseUI.worksheet.publishedAt.formattedDateWithYear}
            </ReactTooltip>
        }
        {
          isPresent(ExerciseUI.worksheet.contentPublishedAt) && ExerciseUI.worksheet.contentPublishedOnADifferentDay &&
            <InfoTooltip
              position='right'
              icon='calendar'
              color='#636363'
              margin='0 5px'
            >
              <div>{`${startCase(ExerciseUI.worksheet.contentType)} originally published on`}</div>
              <div>{ExerciseUI.worksheet.contentPublishedAt.fullTextFormattedDateWithYear}</div>
            </InfoTooltip>
        }
        {
          ExerciseUI.worksheet.episodeCode &&
            <span>{` · ${ExerciseUI.worksheet.episodeCode}`}</span>
        }
      </PublicationDate>
      {
        (isPresent(ExerciseUI.worksheet.worksheetTags) || isPresent(ExerciseUI.worksheet.episodeCode)) &&
          <Tags
            width={null}
            worksheet={ExerciseUI.worksheet}
            onUpdateFilter={goBackToPosts}
          />
      }
    </SubtitleRow>
  );
});

export default WorksheetSubtitleRow;